<app-auth-loader [shouldHide]="shouldHideLoader()"></app-auth-loader>
<app-guard-loading-indicator></app-guard-loading-indicator>
<router-outlet></router-outlet>

<!-- Modal Outlet Container -->
<app-modal-outlet-container></app-modal-outlet-container>